export default "__VITE_ASSET__B0o7rF4v__"